import Popover from 'bootstrap/js/src/popover';
import Cookies from 'js-cookie';

const initPaymentInstallmentPopover = (triggerElementSelector, popoverParams) => {
	      const triggerElement = document.querySelector(triggerElementSelector);
	      
		  if (!triggerElement) {
		      return;
          }
		  
	      new Popover(triggerElement, popoverParams);
	      
	      triggerElement.addEventListener('shown.bs.popover', () => {
		      const popover = Popover.getOrCreateInstance(triggerElement);
		      
		      popover.tip.querySelector('.confirmBtn').addEventListener(
			      'click',
			      () => {
				      popover.hide();
			      }
		      );
	      });
      },
      
      initPaymentInstallmentMobilePopover = () => {
	      initPaymentInstallmentPopover(
		      '#filterGroupsModal .paymentInstallmentPopoverTrigger',
		      {
			      'placement': 'bottom'
		      }
	      );
      },
      
      initPaymentInstallmentDesktopPopover = () => {
	      initPaymentInstallmentPopover(
			  '.arrangement-list-header .paymentInstallmentPopoverTrigger',
		      {
			      'placement': 'top'
		      }
		  );
      },
      
      showPaymentInstallmentPopoversOnce = () => {
	      if (Cookies.get('paymentInstallmentPopover')) {
		      return;
	      }
	      
	      const triggerElementParent = document.querySelector(
		      window.innerWidth <= 767 ? '#filterGroupsModal' : '.arrangement-list-header'
	      );
	      
	      if (!triggerElementParent) {
              return;
	      }
	      
	      triggerElementParent.querySelector('.paymentInstallmentPopoverTrigger').click();
	      
	      Cookies.set(
		      'paymentInstallmentPopover',
		      '1',
		      {
			      'expires': 365
		      }
	      );
      },
      
      initPaymentInstallmentPopovers = () => {
	      initPaymentInstallmentMobilePopover();
	      initPaymentInstallmentDesktopPopover();
	      showPaymentInstallmentPopoversOnce();
      };

export {
	initPaymentInstallmentPopovers,
	initPaymentInstallmentMobilePopover
};